export default __webpack_public_path__ + "static/media/IMG-20240729-WA0007.1279e28a.jpg";